import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductGuildsAssign } from '@/features/guilds/Assign'

export const Route = createFileRoute(
  '/_event/guilds/$guildId/entrar'
)({
  component: DigitalProductGuildsAssignPage
})

function DigitalProductGuildsAssignPage() {
  return <DigitalProductGuildsAssign />
}
